import { Tooltip } from '@material-ui/core';
import StandardButton from 'components/button-standard/standard-button';
import { formatCurrency } from 'components/fomatter/currency/currency-formatter';
import { FundSeriesAndInvestor } from 'model/series';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFundAndSeriesContext } from 'shared/fund-and-series-selection/fund-and-series-selection-context';
import useInvestorPortalBlockedIssuers from 'shared/hooks/use-investor-portal-blocked-issuers';
import { formatHiddenBalance } from 'shared/util/investor-portal-blocked-issuers-utils';
import SelectAllChartBar from '../select-all-chart-bar/select-all-chart-bar';

interface SelectAllCardProps {
    fundAndSeries: FundSeriesAndInvestor;
    action: () => void;
    dataCy: string;
}

const SelectAllCard = (props: SelectAllCardProps) => {
    const { fundAndSeries, action, dataCy } = props;

    const { selectedFundAndSeries } = useFundAndSeriesContext();
    const { isIssuerBlocked } = useInvestorPortalBlockedIssuers();

    const { t } = useTranslation();

    const isAlreadySelected: boolean = selectedFundAndSeries?.seriesId === fundAndSeries.seriesId;
    const isBlockedByUnleash: boolean = isIssuerBlocked(fundAndSeries.fundId);
    const isDisabled: boolean = isAlreadySelected || isBlockedByUnleash;
    const balanceLabel = formatHiddenBalance(isBlockedByUnleash, fundAndSeries?.seriesGrossAmount ?? 0, amount => formatCurrency(amount, 0, true));

    return (
        <div className="select-all-modal--row">
            <div className="select-all-modal--items">
                <SelectAllChartBar />
                <div className="select-all-modal--items__fund">
                    <Tooltip title={fundAndSeries.fundName}>
                        <span>{fundAndSeries.fundName}</span>
                    </Tooltip>
                </div>
                <div className="select-all-modal--items__series">
                    <Tooltip title={fundAndSeries.seriesName}>
                        <span>{fundAndSeries.seriesName}</span>
                    </Tooltip>
                </div>
                <div className="select-all-modal--items__balance">
                    <span className="select-all-modal--items__balance-title">{t('wallet.modal.balance')}</span>
                    <Tooltip title={balanceLabel}>
                        <span>{balanceLabel}</span>
                    </Tooltip>
                </div>
                <div className="select-all-modal--items__button">
                    <Tooltip title={isBlockedByUnleash ? t('wallet.modal.issuer-blocked-tooltip') : ''}>
                        <span>
                            <StandardButton label={t('wallet.modal.button')} onClick={action} disabled={isDisabled} dataCy={dataCy} />
                        </span>
                    </Tooltip>
                </div>
            </div>
        </div>
    );
};

export default SelectAllCard;
